import { render } from "./ErpRelation.vue?vue&type=template&id=4f0d461d&scoped=true"
import script from "./ErpRelation.vue?vue&type=script&lang=js"
export * from "./ErpRelation.vue?vue&type=script&lang=js"

import "./ErpRelation.vue?vue&type=style&index=0&id=4f0d461d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0d461d"]])

export default __exports__